import { atom, DefaultValue, selector } from "recoil"
import { Views } from "../../../constants"
import { TypeViewDependingLayout } from "./types"

const viewAtom = atom({
  key: "view",
  default: Views.LOADING
})

export const viewDependingLayoutAtom = atom<TypeViewDependingLayout>({
  key: "viewDependingLayoutAtom",
  default: {
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    isLandscape: false,
    isTransparent: false
  }
})

export const viewSelector = selector({
  key: "viewSelector",
  get: ({ get }) => {
    return get(viewAtom)
  },
  set: ({ set }, newView: string | DefaultValue) => {
    set(viewAtom, newView)
  }
})

export const viewCallbackSelector = selector({
  key: "viewCallbackSelector",
  get: ({ getCallback, get }) => {
    const getCurrentView = getCallback(({ snapshot }) => async () => {
      const data = await snapshot.getPromise(viewAtom)
      return data
    })
    return { getCurrentView }
  }
})
